import React from 'react';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import CareTeamMemberHeader from '../CareTeam/CareTeamMemberHeader';
import CareTeamMemberDetails from '../CareTeam/CareTeamMemberDetails';
import InsuranceCards from '../CareTeam/InsuranceCards';
import { useOrganizationId } from '../../../hooks/api/useOrganization';
import { APITypes } from '../../../primary-record-types';

export type OrganizationCareTeamMemberDetailsOwnProps = {
    organizationCareTeamMemberId: string;
    organizationCareTeamMember: APITypes.organizationService.OrganizationCareTeamMemberDetails;
};

export type OrganizationCareTeamMemberDetailsProps = OrganizationCareTeamMemberDetailsOwnProps;

const OrganizationCareTeamMemberDetails: React.FC<OrganizationCareTeamMemberDetailsProps> = ({
    organizationCareTeamMemberId,
    organizationCareTeamMember,
}) => {
    const organizationId = useOrganizationId();
    return (
        <Stack vertical align="center" space={contentStackSpacing}>
            <CareTeamMemberHeader
                careTeamMemberId={organizationCareTeamMemberId}
                source={{
                    source: 'organization',
                    organizationId: organizationId,
                }}
                careTeamMember={organizationCareTeamMember!}
            />
            <CareTeamMemberDetails careTeamMember={organizationCareTeamMember!} />
            {organizationCareTeamMember?.careTeamMemberType === 'insurance' ? (
                <InsuranceCards
                    careTeamMemberId={organizationCareTeamMemberId}
                    source={{
                        source: 'organization',
                        organizationId,
                    }}
                />
            ) : null}
        </Stack>
    );
};

export default React.memo(OrganizationCareTeamMemberDetails);
